import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSesion } from '../contexto/Sesion.js';
import { ErrorApi } from '../api/cliente.js';

export function LoginPortal() {
  const { loginPortal } = useSesion();
  const navegar = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      await loginPortal(email, password);
      navegar('/portal');
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo iniciar sesión');
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="web" style={{ maxWidth: 420, paddingTop: 64 }}>
      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <h1 style={{ color: 'var(--verde)' }}>Ausentia</h1>
        <p className="mini" style={{ margin: '-8px 0 8px' }}>by AtuelSoft</p>
        <p className="muted">Portal de la empresa cliente</p>
      </div>
      <form onSubmit={enviar} className="tarjeta" style={{ padding: 20 }}>
        <div className="campo">
          <label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="campo">
          <label>Contraseña</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <div className="error-box">{error}</div>}
        <button className="primario" disabled={cargando}>{cargando ? 'Ingresando…' : 'Ingresar'}</button>
      </form>
      <p style={{ textAlign: 'center', marginTop: 14 }}><Link to="/">← Volver al inicio</Link></p>
    </div>
  );
}
